module.exports = __webpack_public_path__ + "static/media/TopAtlantico.ddbd7acc.jpg";